import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listar-areas',
  templateUrl: './listar-areas.component.html',
  styleUrls: ['./listar-areas.component.scss']
})
export class ListarAreasComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
